import { DRAG_TYPES } from '../constants/dnd';
import { layoutNodeTypes } from '../constants/dndAreaHoverPositionConstants';
export function isExistingModuleDragItem(dragItem) {
  return !!dragItem && dragItem.type === DRAG_TYPES.EXISTING_ITEM && dragItem.layoutNodeType === layoutNodeTypes.GRID_LAYOUT_MODULE;
}
export function isExistingItemDragItem(dragItem) {
  return !!dragItem && dragItem.type === DRAG_TYPES.EXISTING_ITEM;
}
export function isAddModuleDragItem(dragItem) {
  return !!dragItem && dragItem.type === DRAG_TYPES.ADD_MODULE;
}
export function isMultiItemDragItem(dragItem) {
  return !!dragItem && dragItem.type === DRAG_TYPES.MULTI_ITEM;
}
export function getAllDragIds(dragItem) {
  if (isMultiItemDragItem(dragItem)) {
    return dragItem.dragIds;
  }
  return dragItem.dragId ? [dragItem.dragId] : [];
}